
import { Component, Prop, Emit, Watch, Vue, Mixins } from 'vue-property-decorator';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';
import imageConvert from '@/utils/image';
import itemMixin from '@/minix/itemMixin';
import api from '@/api';

const { swapInPoint } = api;

@Component({
  components: { DateTimePicker },
})
export default class SwapInPointForm extends Mixins(Vue.extend(itemMixin)) {
  @Prop({}) private itemId!: string;

  @Prop({}) private itemName!: string;

  @Prop({}) private itemLogo!: string;

  @Prop({}) private descriptionUrl!: string;

  @Prop({}) private serviceFee!: string;

  @Prop({}) private serviceFeePercentage!: string;

  @Prop({}) private incomePerPoint!: string;

  @Prop({}) private link!: string;

  @Prop({}) private categoryClasses!: [];

  @Prop({}) private sort!: number;

  @Prop({ default: false }) public loading!: boolean;

  @Prop({ default: false }) public isEdit!: boolean;

  public valid: boolean = false;

  merchantList: Merchant[] = [];

  public logoUrl: any = '';

  public categoryId: any = '';

  public typeManagementList: any = [];

  public form = {
    itemId: this.itemId,
    itemName: this.itemName,
    itemLogo: this.itemLogo,
    descriptionUrl: this.descriptionUrl,
    highestExchangeRate: null,
    exchangeRate: null,
    lowestExchangeRate: null,
    incomePerPoint: this.incomePerPoint,
    serviceFee: this.serviceFee,
    serviceFeePercentage: this.serviceFeePercentage,
    link: this.link,
    categoryClasses: this.categoryClasses,
    sort: this.sort,
    logoUrl: this.itemLogo,
  };

  public rules = {
    name: [this.requiredRule('名稱'), this.maxLengthRule('名稱', 50)],
    merchant: [this.requiredRule('供應商')],
    logUrl: [...this.validatePic((vm: SwapInPointForm) => vm.logoUrl)],
    rateRule: [this.requiredRule('匯率')],
    serviceFeeRule: [...this.getNumberRule('手續費')],
    serviceFeePercentageRule: [...this.getNumberRule('手續費百分比')],
    typeRule: [(v: any) => !!v.length || '點數類別必填'],
    incomePerPoint: this.getNumberRule('消耗成本'),
    sort: this.getNumberRule('排序'),
  };

  public get merchantOptions() {
    const mcId = this.categoryId;
    return this.merchantList
      .filter((m: any) => !mcId || mcId === m.categoryId)
      .map((m: any) => ({
        text: m.merchantName,
        value: m.merchantId,
      }));
  }

  private async setTypeManagementList() {
    const { data } = await swapInPoint.typeList();
    this.typeManagementList = data || [];
  }

  private setCategoryId() {
    const merchant = this.merchantList
      .find((m: any) => this.form.itemId === m.merchantId);
    this.categoryId = merchant && merchant.categoryId;
  }

  private get inputs() {
    return {
      itemId: this.itemId,
      itemName: this.itemName,
      itemLogo: this.itemLogo,
      descriptionUrl: this.descriptionUrl,
      highestExchangeRate: null,
      exchangeRate: null,
      lowestExchangeRate: null,
      incomePerPoint: this.incomePerPoint,
      serviceFee: this.serviceFee,
      serviceFeePercentage: this.serviceFeePercentage,
      link: this.link,
      categoryClasses: this.categoryClasses || [],
      sort: this.sort,
    };
  }

  @Watch('inputs', { immediate: true })
  private inputsWatcher(val: any) {
    this.form = {
      ...val,
    };
    this.logoUrl = this.itemLogo;
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private maxLengthRule(column: string, length: number) {
    return (v: any) => v?.length <= length || `${column} 最多 ${length} 字`;
  }

  private validatePic(func: (vm: SwapInPointForm) => any) {
    return [
      (v: any) => {
        const p = func(this);
        return !!v || !!p || '請上傳圖片';
      },
      (v: any) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
    ];
  }

  private getNumberRule(column: string) {
    return [
      (v: any) => /^\d+(\.\d+)?$/.test(v) || `${column} 必須是數字`,
      (v: any) => v !== '' || `${column} 為必填`,
    ];
  }

  public handleClearImage() {
    this.form.itemLogo = '';
    this.logoUrl = '';
  }

  public changeImage(event: any) {
    if (event) {
      const imagePic = URL.createObjectURL(event);
      this.form.itemLogo = event;
      this.logoUrl = imagePic;
    }
  }

  public async cancel() {
    await this.$router.back();
  }

  @Emit()
  public async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      return {
        ...this.form,
        itemLogo: await imageConvert(this.form.itemLogo as any),
        categoryClasses: this.form.categoryClasses.map((c: number) => ({ catId: c })),
      };
    }
    return null;
  }

  private async mounted() {
    await this.setTypeManagementList();
    if (this.isEdit) {
      this.setCategoryId();
    }
  }
}
